export default __webpack_public_path__ + "images/ic_playbutton-schrift.svg";